import { CartItemSkuAddOn, CartSummary, CartInput } from 'microshop-api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CartRowProduct from './CartRowProduct';

export type QuantityChangedFunction = (input: {
    sku: string | number;
    qty: number;
    addons?: CartItemSkuAddOn[];
    collectionId?: number | null;
    splitId?: number | undefined;
    inputs?: CartInput[];
    split?: string | null;
    immediate?: boolean;
}) => void;

type CartItemsProps = {
    onChangeQuantity: QuantityChangedFunction;
    onRemove: (sku: string) => void;
    onSetComment: (sku: string, comment: string) => void;
    forceSize?: any;
    cart: CartSummary;
};

const CartItems = ({ onChangeQuantity, onRemove, onSetComment, cart, forceSize }: CartItemsProps) => {
    const { t } = useTranslation();
    if (!cart) return null;

    return (
        <>
            <SubHeader className="f1-700">{t('cart')}</SubHeader>
            <ListWrapper className="f1-500 w-100">
                {cart.items?.map((product, i) => {
                    return (
                        <CartRowProduct
                            onChangeQuantity={onChangeQuantity}
                            onRemove={onRemove}
                            onSetComment={onSetComment}
                            key={`${product.number}_${i}`}
                            product={product}
                            forceSize={forceSize}
                        />
                    );
                })}
            </ListWrapper>
        </>
    );
};

export default CartItems;

const SubHeader = styled.h4`
    font-size: 22px;
`;
const ListWrapper = styled.div`
    font-size: 12px;
`;
